import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  useTheme,
  useMediaQuery
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import GradientBackground from '../components/GradientBackground';
const SignUpPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const options = [
    {
      title: 'Vender',
      description: 'Registrate como vendedor para ofrecer tus productos a miles de compradores. Ideal para distribuidores, mayoristas y fabricantes.',
      icon: <StorefrontIcon sx={{ fontSize: 80, color: 'white' }} />,
      benefits: [
        'Gestiona tu catálogo de productos',
        'Recibe pedidos directamente a tu mail o WhatsApp',
        'Amplía tu red de clientes',
        '¡Registrate sin cargo!'
      ],
      path: '/signup-distributor',
      color: '#FF6B00'
    },
    {
      title: 'Comprar',
      description: 'Registrate como comprador para acceder a los mejores precios mayoristas. Ideal para comercios, restaurantes y revendedores.',
      icon: <ShoppingCartIcon sx={{ fontSize: 80, color: 'white' }} />,
      benefits: [
        'Accede a precios mayoristas',
        'Conectá con distribuidores de tu zona o de todo el país',
        'Compará precios fácilmente',
        '¡Registrate sin cargo!',
      ],
      path: '/signup-business',
      color: '#2196F3'
    }
  ];

  return (
    <GradientBackground>
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography
        component="h1"
        variant="h4"
        align="center"
        gutterBottom
        sx={{ mb: 6, color: 'text.light',fontWeight: 'bold' }}
      >
        ¿Cómo querés usar Liderdist?
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {options.map((option) => (
          <Grid item xs={12} sm={6} key={option.title}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
                borderRadius: 2,
                overflow: 'hidden'
              }}
            >
              <Box
                sx={{
                  bgcolor: option.color,
                  py: 4,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {option.icon}
              </Box>
              <CardContent sx={{ flexGrow: 1, pt: 2 }}>
                <Typography gutterBottom variant="h5" component="h2" align="center" sx={{ fontWeight: 'bold' }}>
                  {option.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph align="center">
                  {option.description}
                </Typography>
                <Box sx={{ mt: 2 }}>
                  {option.benefits.map((benefit, index) => (
                    <Typography
                      key={index}
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                        '&:before': {
                          content: '"•"',
                          color: option.color,
                          fontWeight: 'bold',
                          marginRight: 1
                        }
                      }}
                    >
                      {benefit}
                    </Typography>
                  ))}
                </Box>
              </CardContent>
              <CardActions sx={{ p: 2, pt: 0 }}>
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  onClick={() => navigate(option.path)}
                  sx={{
                    bgcolor: option.color,
                    '&:hover': {
                      bgcolor: option.color,
                      filter: 'brightness(0.9)'
                    }
                  }}
                >
                  Registrarse como {option.title === 'Vender' ? 'vendedor' : 'comprador'}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
    </GradientBackground>
  );
};

export default SignUpPage; 